import PercentRegistration from './PercentRegistration';

export default PercentRegistration;
